const Add = () => (
  <svg
    id="add"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 32.91 34.793"
  >
    <path
      id="Path_41"
      data-name="Path 41"
      d="M31.879,28.37a8.474,8.474,0,0,1,7.443-8.4V1.019A1.02,1.02,0,0,0,38.3,0H21.574V6.7A1.019,1.019,0,0,1,20.555,7.72h-6.7V33.774a1.02,1.02,0,0,0,1.019,1.019H34.838A8.446,8.446,0,0,1,31.879,28.37Zm-13.971-18.1H34.871a1.019,1.019,0,1,1,0,2.039H17.908a1.019,1.019,0,1,1,0-2.039Zm0,4.585H34.871a1.019,1.019,0,1,1,0,2.039H17.908a1.019,1.019,0,1,1,0-2.039ZM28.39,30.644H17.908a1.019,1.019,0,0,1,0-2.039H28.39a1.019,1.019,0,0,1,0,2.039Zm0-4.585H17.908a1.019,1.019,0,1,1,0-2.039H28.39a1.019,1.019,0,0,1,0,2.039Zm0-4.585H17.908a1.019,1.019,0,0,1,0-2.039H28.39a1.019,1.019,0,0,1,0,2.039Z"
      transform="translate(-13.854)"
      fill="inherit"
    />
    <path
      id="Path_42"
      data-name="Path 42"
      d="M19.535,0,13.854,5.681H19.2a.34.34,0,0,0,.34-.34Z"
      transform="translate(-13.854)"
      fill="inherit"
    />
    <path
      id="Path_43"
      data-name="Path 43"
      d="M315.523,322.954a6.423,6.423,0,1,0,6.423,6.423A6.431,6.431,0,0,0,315.523,322.954Zm3.031,7.443h-2.011v2.011a1.019,1.019,0,1,1-2.039,0V330.4h-2.011a1.019,1.019,0,0,1,0-2.039H314.5v-2.011a1.019,1.019,0,0,1,2.039,0v2.011h2.011a1.019,1.019,0,1,1,0,2.039Z"
      transform="translate(-289.036 -301.008)"
      fill="inherit"
    />
  </svg>
);

export default Add;
